export const paginationMixin = {
  methods: {},
};
